import React from "react";

import {createRoot} from 'react-dom/client';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import AlertController from "./components/AlertController";
import LoadingController from "./components/LoadingController";
import NotFound from "./components/NotFound";
import TheCellMapNavbar from "./components/TheCellMapNavbar";
import {TheCellMapProvider} from "./contexts/TheCellMapContext";
import About from "./pages/AboutPage";
import Gene from "./pages/GenePage";
import Help from "./pages/HelpPage";
import List from "./pages/ListPage";
import TheCellMap from "./pages/NetworkPage";
import Overlay from "./pages/OverlayPage";
import Subnetwork from "./pages/SubNetworkPage";
import {patchWebGLContext} from "./preserveContextPatch";

import {AppSettings} from "./settings";
import "./css/variables.css";
import "./css/style.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import MatomoTrackerComponent from "./utils/tracker";

const container = document.getElementById('root');
const root = createRoot(container!);

patchWebGLContext();

const disableAutocorrect = (el: Element) => {
  el.setAttribute('autocomplete', 'off');
  el.setAttribute('autocorrect', 'off');
  el.setAttribute('autocapitalize', 'off');
  el.setAttribute('spellcheck', 'false');
};

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      const el = node as Element;
      if (el.matches('input, textarea')) disableAutocorrect(el);
      el.querySelectorAll('input, textarea').forEach(disableAutocorrect);
    }
  }
}).observe(document.body, {childList: true, subtree: true});

root.render(
  <React.StrictMode>
    <BrowserRouter basename={AppSettings.LOCAL_URL_PREFIX}
                   future={{
                     v7_startTransition: true,
                     v7_relativeSplatPath: true
                   }}>
      <TheCellMapNavbar/>

      <div id="page-content" className="flex-fill d-flex flex-column">
        <TheCellMapProvider>
          <LoadingController/>
          <AlertController/>
          <MatomoTrackerComponent/>
          <Routes>
            <Route path="/" element={<TheCellMap/>}/>
            <Route path="overlay" element={<Overlay/>}/>
            <Route path="list" element={<List/>}/>
            <Route path="subnetwork" element={<Subnetwork/>}/>
            <Route path="about" element={<About/>}/>
            <Route path="help" element={<Help/>}/>
            <Route path="gene/:identifier" element={<Gene/>}/>
            <Route path="*" element={<NotFound/>}/>
          </Routes>
        </TheCellMapProvider>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);
